import { PAGES } from '@/constants/pages';

export default {
  navigation: [
    {
      name: PAGES.orders.title,
      items: [
        {
          name: PAGES.orders.supplier.title,
          link: PAGES.orders.supplier.name,
        },
        {
          name: PAGES.orders.new_order.title,
          link: PAGES.orders.new_order.name,
        },
        {
          name: PAGES.orders.dealer.title,
          link: PAGES.orders.dealer.name,
        },
        {
          name: PAGES.orders.retail.title,
          link: PAGES.orders.retail.name,
        },
      ],
    },
    {
      name: PAGES.dealers.title,
      link: PAGES.dealers.name,
    },
    {
      name: 'Настройки',
      items: [
        {
          name: PAGES.profile.title,
          link: PAGES.profile.name,
        },
        {
          name: PAGES.payers.title,
          link: PAGES.payers.name,
        },
        {
          name: PAGES.warehouse.title,
          link: PAGES.warehouse.name,
        },
        {
          name: 'Сотрудники',
          link: PAGES.employees.name
        },
        {
          name: 'Права доступа',
          link: 'access-rights',
        },
        {
          name: 'Розничные наценки',
          link: PAGES.markup.name,
        },
      ],
    },
    {
      name: 'Отчеты',
      items: [
        {
          name: PAGES.reports.title,
          link: PAGES.reports.name,
        },

        {
          name: PAGES.report_selling.title,
          link: PAGES.report_selling.name,
        },
        {
          name: PAGES.reports_orders.title,
          link: PAGES.reports_orders.name,
        },
        {
          name: PAGES.reports_by_materials_zgi.title,
          link: PAGES.reports_by_materials_zgi.name,
        },
        {
          name: PAGES.balance.title,
          link: PAGES.balance.name,
        },
        {
          name: PAGES.invoices.title,
          link: PAGES.invoices.name,
        },
        {
          name: PAGES.shippings.title,
          link: PAGES.shippings.name,
        },
        {
          name: PAGES.special_prices.title,
          link: PAGES.special_prices.name,
        }
      ]
    },
    {
      name: 'Рекламации',
      items: [
        {
          name: PAGES.reclamations_supplier.title,
          link: PAGES.reclamations_supplier.name,
        },
        {
          name: PAGES.reclamations_dealers.title,
          link: PAGES.reclamations_dealers.name,
        },
      ]
    },
    {
      name: PAGES.documents.title,
      link: PAGES.documents.name,
    },
    {
      name: PAGES.photoGallery.title,
      link: PAGES.photoGallery.name,
    },
    {
      name: PAGES.notifications.title,
      link: PAGES.notifications.name,
    },
  ],
  notifications: null,
  profileBalance: null,
  services: null,

  reports: null,

  reportsOrdersFromDealers: null,
  reportsOrdersFromDealersHeaders: null,
  reportsOrdersFromDealersTotal: null,

  reportsOrdersToSupplier: null,
  reportsOrdersToSupplierHeaders: null,

  reportsOrdersRetail: null,
  reportsOrdersRetailHeaders: null,

  reportsSellingZgi: null,
  reportsSellingCut: null,
  reportsSellingOpt: null,

  // Тут сохраняется id заказа, модалку для которого нужно открыть
  needOpenModal: null,

  // Открыто/закрыто меню
  menu: false,

  // Статус загрузки
  loading: false,

  // Статус загрузки в модалке
  loadingInPopup: false,

  // Режим редактирования
  editMode: false,

  // Редактируемое поле
  editField: '',

  // Список сотрудников
  employees: [],

  // Выбранный сотрудник для редактирования
  selectedEmployee: null,

  // Список дилеров
  dealers: [],

  // Список отфильтрованных дилеров
  filteredDealers: [],

  //
  sortMap: {
    ordersB2C: {
      // orderNum: 'desc',
      created_at: 'desc',
    },
    ordersB2B: {
      // orderNum: 'desc',
      created_at: 'desc',
    },
    ordersExternal: {
      // orderNum: 'desc',
      created_at: 'desc',
    },
    employees: {
      name: 'asc',
    },
    dealers: {
      index: 'asc',
      // id: 'asc',
      // dealer_name: 'asc',
    },
  },

  // Статусы заказа
  orderStatuses: [], // TODO:: возможно не нужны будут!!!!!!!!!

  // Статусы заказов
  orderStatusList: [],

  // Выбранный заказ
  selectedOrder: null,

  // Список всех заказов
  ordersAll: [],

  // Розничные заказы
  ordersB2C: [],

  // Заказы от дилера
  ordersB2B: [],

  // Заказы поставщику
  ordersExternal: [],

  // Наценки
  markups: [],

  // Список валют
  currencies: [],

  // Тип курса
  rates: [
    {value: 0, label: 'По курсу ЦБ', disabled: false},
    {value: 1, label: 'Фиксированный', disabled: false}
  ],

  // Единицы измерения
  units: [
    {value: 1, label: 'Миллиметры'},
    {value: 2, label: 'Сантиметры'},
    {value: 3, label: 'Метры'},
  ],
  // для 'Список РНК'
  profileInvoices: [],

  // Для Отгрузок
  profileShippings: []
}
